/* eslint import/prefer-default-export: "off" */
import ObjectsContainer from '@src/modules/objects'
import Identities from '@src/modules/identities'
import SearchResultContainer from '@src/modules/search.result'
import SettingsContainer from '@src/modules/settings'
import PublicObjects from '@src/modules/public.objects'
import ShadowAccessContainer from '@src/modules/shadow.access'
import UnusedSAccess from '@src/modules/unused.access'
import type { RouteProps } from '../helpers/router.helper'
import { Routes } from '@src/modules/../constants/routes'
import SetupWizard from '@src/modules/setup.wizard'
import loadable from '@loadable/component'
import Loading from '@src/components/loading'

interface Route extends RouteProps {}

const PrivilegesContainerLoadableComponent = loadable(
  () => import('@src/modules/privileges'),
  {
    fallback: Loading
  }
)

const ChangesPageLoadableComponent = loadable(
  () => import('@src/modules/changes'),
  {
    fallback: Loading
  }
)

const ReportsPageLoadableComponent = loadable(
  () => import('@src/modules/reports'),
  {
    fallback: Loading
  }
)

const MonitoringContainerLoadableComponent = loadable(
  () => import('@src/modules/guardrails'),
  {
    fallback: Loading
  }
)

const AlertsLoadableComponent = loadable(() => import('@src/modules/alerts'), {
  fallback: Loading
})

const ComplianceLoadableComponent = loadable(
  () => import('@src/modules/compliance'),
  {
    fallback: Loading
  }
)

const AccountsLoadableComponent = loadable(
  () => import('@src/modules/accounts'),
  {
    fallback: Loading
  }
)

const DashboardLoadableComponent = loadable(
  () => import('@src/modules/dashboard'),
  {
    fallback: Loading
  }
)

const NetworksLoadableComponent = loadable(
  () => import('@src/modules/networks'),
  {
    fallback: Loading
  }
)

export const routes = {
  dashboard: {
    path: Routes?.pages?.dashboard?.path,
    withFilter: true,
    component: DashboardLoadableComponent
  } as Route,
  objects: {
    path: Routes?.pages?.objects?.path,
    component: ObjectsContainer
  } as Route,
  identities: {
    path: Routes?.pages?.identities?.path,
    component: Identities
  } as Route,
  searchResult: {
    path: Routes?.pages?.searchResult?.path,
    withFilter: true,
    component: SearchResultContainer
  } as Route,
  compliance: {
    path: Routes?.pages?.compliance?.path,
    component: ComplianceLoadableComponent
  },
  guardrails: {
    path: Routes?.pages?.guardrails?.path,
    component: MonitoringContainerLoadableComponent
  } as Route,
  changes: {
    path: Routes?.pages?.changes?.path,
    withFilter: true,
    component: ChangesPageLoadableComponent
  } as Route,
  alerts: {
    path: Routes?.pages?.alerts?.path,
    component: AlertsLoadableComponent
  } as Route,
  setup: {
    path: Routes?.pages?.setup?.path,
    exact: true,
    component: SetupWizard
  } as Route,
  settings: {
    path: Routes?.pages?.settings?.path,
    exact: true,
    component: SettingsContainer
  } as Route,
  accounts: {
    path: Routes?.pages?.sources?.path,
    component: AccountsLoadableComponent
  } as Route,
  privileges: {
    path: Routes?.pages?.privileges?.path,
    withFilter: true,
    component: PrivilegesContainerLoadableComponent
  } as Route,
  publicObjects: {
    path: Routes?.pages?.publicObjects?.path,
    withFilter: true,
    component: PublicObjects
  } as Route,
  shadowAccess: {
    withFilter: true,
    path: Routes?.pages?.shadowAccess?.path,
    component: ShadowAccessContainer
  } as Route,
  unusedSAccess: {
    path: Routes?.pages?.unusedSAccess?.path,
    component: UnusedSAccess
  } as Route,
  networks: {
    path: Routes?.pages?.networks?.path,
    component: NetworksLoadableComponent
  } as Route,
  reports: {
    path: Routes?.pages?.reports.path,
    component: ReportsPageLoadableComponent,
    withFilter: true
  } as Route
}
